import Headroom from 'headroom.js'
import scrollMonitor from 'scrollmonitor'

//Headroom and slider nav functionality
const initHeader = () => {
  let headroom = new Headroom(document.querySelector('header'), {
      tolerance: 10,
    })
  headroom.init()
  $(document).on('click', '[data-toggle-nav]', () => {
    $('.menu-btn').toggleClass('active')
    $('.mobile').toggleClass('nav-active')
    $('body').toggleClass('no-scroll')
  })
}

/**
 * Fade in text for textWithImage blocks.
 */
const fadeInText = () => {
  const fadeInEvent = ($el) => {
    let el = $el[0],
      watcher = scrollMonitor.create(el, -250)

    watcher.one('enterViewport', () => {
      $el.find('.faded').addClass('in-view')
    })
  }

  $('.block\\(hero\\), .block\\(doubleImage\\), .block\\(imageAndText\\), .block\\(cta\\), .block\\(offerings\\), .block\\(textAndList\\)').each(function () {
    fadeInEvent($(this))
  })
}

export default {
  init() {
    // JavaScript to be fired on all pages
  },
  finalize() {
    initHeader()
    fadeInText()
  },
};



// WEBPACK FOOTER //
// ./scripts/routes/common.js